import { BatchTracingSpec } from '../spec/batch-tracing-spec'
import { BatchTracingConf } from '../conf/batch-tracing-conf'

export class TracedMaterial {
  constructor(
    public itemInfo: ItemInfo,
    public workCenterId: string,
    public materialInfo: MaterialInfo,
    public spec: BatchTracingSpec,
    public conf: BatchTracingConf
  ) {}
}

export class ItemInfo {
  constructor(
    public id: string,
    public number: string
  ) {}
}

export class MaterialInfo {
  constructor(
    public path: string,
    public id: string,
    public searchTerm: string
  ) {}
}
